import { Injectable } from '@angular/core';
import {
    CheckoutData,
    PaymentStatus,
    PaymentSuccessData,
} from './checkout.model';

@Injectable({
    providedIn: 'root',
})
export class PaymentPeachUtilsService {
    private regexToPaymentStatusList = [
        {
            regex: RegExp('^(000.000.|000.100.1|000.[36]|000.400.[1][12]0)'),
            orderStatus: PaymentStatus.COMPLETED,
        },
        {
            regex: RegExp('^(000.200)'),
            orderStatus: PaymentStatus.PENDING,
        },
        {
            regex: RegExp('^(800\.400\.5|100\.400\.500)'),
            orderStatus: PaymentStatus.PENDING,
        },
        {
            regex: RegExp('^.'),
            orderStatus: PaymentStatus.FAILED,
        },
    ];

    public getPaymentStatusPeach(checkoutEvent: CheckoutEvent): PaymentStatus {
        const { orderStatus } = this.regexToPaymentStatusList.find(
            ({ regex }) => regex.test(checkoutEvent.result.code)
        );

        return orderStatus;
    }

    public constructSuccessQueryParamsPeach(
        checkoutEvent: CheckoutEvent,
        checkoutData: CheckoutData,
        orderStatus: PaymentStatus
    ): PaymentSuccessData {
        const { orderId } = checkoutData;

        const {
            amount,
            'customParameters[customerName]': customerName,
            'customParameters[customerEmail]': customerEmail,
        } = checkoutEvent;

        return {
            orderId,
            orderStatus,
            orderNumber: 0,
            amount: +amount,
            name: customerName,
            email: customerEmail,
            paymentDetails: `${checkoutEvent.result.description} (${checkoutEvent.resultDetails.ExtendedDescription})`,
        };
    }
}
